import { Link } from "react-router-dom";

export const SubMenu = ({ filters, handleUrl }) => {
  return (
    <div className="row p-box-filters">
      <div className="col p-box-filters-items">
        <Link
          to="/facturas/?q=t"
          className={filters.q === "t" ? "selected" : ""}
          onClick={() => handleUrl("t")}
        >
          Todo
        </Link>
        <Link
          to="/facturas/?q=pc"
          className={filters.q === "pc" ? "selected" : ""}
          onClick={() => handleUrl("pc")}
        >
          Facturas por cobrar
        </Link>
        <Link
          to="/facturas/?q=cd"
          className={filters.q === "cd" ? "selected" : ""}
          onClick={() => handleUrl("cd")}
        >
          Facturas con detracción
        </Link>
        <Link
          to="/facturas/?q=pcd"
          className={filters.q === "pcd" ? "selected" : ""}
          onClick={() => handleUrl("pcd")}
        >
          Facturas por cobrar detracción
        </Link>
        <Link
          to="/facturas/?q=pv"
          className={filters.q === "pv" ? "selected" : ""}
          onClick={() => handleUrl("pv")}
        >
          Facturas por vencer
        </Link>
        <Link
          to="/facturas/?q=v"
          className={filters.q === "v" ? "selected" : ""}
          onClick={() => handleUrl("v")}
        >
          Facturas vencidas
        </Link>
      </div>
    </div>
  );
};
